import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export { FETCH_HOUSEHOLD_ATTACHED_MODEL } from '@ovComponents/4-module/widgets/portfolio/components/queries';

const HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_FIELDS = `
  id
  name
  key
  translatedName { ${TRANSLATED_STRING_FIELDS} }
`;

const HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_BRANCH_FIELDS = `
  id
  targetPercentage
  assetClass {
    ${HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_FIELDS}
  }
`;

/** Children + asset-class branches for allocation donut/table. */
const HOUSEHOLD_MODEL_PORTFOLIO_ALLOCATION_CHILD_FIELDS = `
  id
  percentage
  isCashEquivalent
  taxRank
  assetClass {
    ${HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_FIELDS}
  }
  financialProduct {
    id
    name
    ticker
    isCash
    taxRank
    translatedName { ${TRANSLATED_STRING_FIELDS} }
    primaryAssetClass {
      ${HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_FIELDS}
    }
    secondaryAssetClass {
      ${HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_FIELDS}
    }
    tertiaryAssetClass {
      ${HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_FIELDS}
    }
  }
`;

const HOUSEHOLD_MODEL_PORTFOLIO_PORTFOLIO_TEMPLATE_FIELDS = `
  id
  name
  state
  translatedName { ${TRANSLATED_STRING_FIELDS} }
  translatedTemplateDescription { ${TRANSLATED_STRING_FIELDS} }
  assetClassBranches {
    ${HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_BRANCH_FIELDS}
  }
`;

/** IPS policy statement + target allocation bands for the IPS tab. */
const HOUSEHOLD_MODEL_PORTFOLIO_IPS_FIELDS = `
  translatedPortfolioDescription { ${TRANSLATED_STRING_FIELDS} }
  translatedInvestmentObjective { ${TRANSLATED_STRING_FIELDS} }
  translatedLiquidity { ${TRANSLATED_STRING_FIELDS} }
  translatedPortfolioDisclaimer { ${TRANSLATED_STRING_FIELDS} }
  targetAllocations {
    min
    max
    secondaryAssetClass {
      ${HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_FIELDS}
    }
  }
`;

/**
 * Read-only model portfolio fields for the household model portfolio widget.
 * Model tab details, allocation, and IPS tab share this query.
 */
export const FETCH_HOUSEHOLD_MODEL_PORTFOLIO_DETAILS = gql`
  query fetchHouseholdModelPortfolioDetails(
    $input: FetchModelPortfolioInput!
  ) {
    fetchModelPortfolio(input: $input) {
      modelPortfolio {
        id
        strategy
        cloneOf
        assignable
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        theme {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        riskProfileName { ${TRANSLATED_STRING_FIELDS} }
        riskReturnLevel
        suggestable
        zeroPercentCash
        lowThresholdScore
        suggestedMinScore
        suggestedMaxScore
        forecastedRateOfReturn
        forecastedStandardDeviation
        translatedUrl { ${TRANSLATED_STRING_FIELDS} }
        assetClassLevel
        assetClassBranches {
          ${HOUSEHOLD_MODEL_PORTFOLIO_ASSET_CLASS_BRANCH_FIELDS}
        }
        portfolioTemplate {
          ${HOUSEHOLD_MODEL_PORTFOLIO_PORTFOLIO_TEMPLATE_FIELDS}
        }
        children {
          ${HOUSEHOLD_MODEL_PORTFOLIO_ALLOCATION_CHILD_FIELDS}
        }
        ${HOUSEHOLD_MODEL_PORTFOLIO_IPS_FIELDS}
      }
    }
  }
`;
